const baseUrl = process.env.STATIC_BASE_URL || `//static.technogramsolutions.com`,
    title = process.env.TITLE || 'Technogram',
    favicon = process.env.FAVICON || 'favicon',
    clientName = process.env.CLIENT_NAME || 'technogramsolutions',
    serviceDomain = process.env.SERVICE_DOMAIN || 'staging.technogramsolutions.com',
    serviceProtocol = process.env.SERVICE_PROTOCOL || 'https',
    redirectionHost = process.env.BASE_HOST || 'dev.technogramsolutions.com:3030',
    juryKey = process.env.JURY_KEY || '',
    env = process.env.NODE_ENV || 'development',
    whitelabelFlag = process.env.WHITELABEL_DISABLED || false,
    path = serviceProtocol + '://' + serviceDomain;

module.exports = { path, favicon, title, baseUrl, clientName, env, serviceDomain, serviceProtocol, redirectionHost, juryKey, whitelabelFlag };
